export default "__VITE_ASSET__BcxXKWyf__"